/* eslint-disable unit-testing/has-unit-test */

export const SUPPORTED_COUNTRY_CODES = [
  'US', 'CA', 'AI', 'AG', 'BB', 'BM', 'VG', 'KY',
  'DM', 'DO', 'GD', 'JM', 'MS', 'SX', 'KN', 'LC',
  'VC', 'BS', 'TT', 'TC',
];

export const ENTITY_TYPE_VALUES = {
  PRIVATE_PROFIT: 'PRIVATE_PROFIT',
  PUBLIC_PROFIT: 'PUBLIC_PROFIT',
  NON_PROFIT: 'NON_PROFIT',
  SOLE_PROPRIETOR: 'SOLE_PROPRIETOR',
};

export const ENTITY_TYPES = [
  { value: ENTITY_TYPE_VALUES.PRIVATE_PROFIT, translationPath: 'texting_wizard.business_info.entity_type.private_profit' },
  { value: ENTITY_TYPE_VALUES.PUBLIC_PROFIT, translationPath: 'texting_wizard.business_info.entity_type.public_profit' },
  { value: ENTITY_TYPE_VALUES.NON_PROFIT, translationPath: 'texting_wizard.business_info.entity_type.non_profit' },
  { value: ENTITY_TYPE_VALUES.SOLE_PROPRIETOR, translationPath: 'texting_wizard.business_info.entity_type.sole_proprietor' },
];

export const DEFAULT_TAX_ID_TYPE = 'EIN';

export const TAX_ID_TYPES = [
  'EIN', 'CBN', 'CRN', 'NEQ', 'PROVINCIAL_NUMBER', 'VAT', 'ACN', 'ABN', 'BRN',
  'SIREN', 'SIRET', 'NZBN', 'UST-IDNR', 'CIF', 'NIF', 'CNPJ', 'UID', 'OTHER',
];

export const MIN_POSTAL_CODE_LENGTH = 5;

// Phone number minimum length (10 digits total, including country code)
export const MIN_PHONE_NUMBER_LENGTH = 10;

// Default country code for phone numbers and addresses
export const DEFAULT_COUNTRY_CODE = 'US';

// Campaign example message length constraints
export const MIN_CAMPAIGN_EXAMPLE_LENGTH = 40;
export const MAX_CAMPAIGN_EXAMPLE_LENGTH = 1000;

// Promotional verification status values
export const PROMOTIONAL_VERIFICATION_STATUS = {
  PENDING: 'pending',
  VERIFIED: 'verified',
};

// Auto Client Messaging tab indices (matches Angular client_notifications tabs)
export const CLIENT_NOTIFICATIONS_TABS = {
  BOOKING: 0,
  PAYMENTS: 1,
};

export const AUTOMATED_TEXT_MESSAGE_CATEGORIES = [
  {
    key: 'bookings',
    selectedTab: CLIENT_NOTIFICATIONS_TABS.BOOKING,
  },
  {
    key: 'invoices',
    selectedTab: CLIENT_NOTIFICATIONS_TABS.PAYMENTS,
  },
  {
    key: 'estimates',
    selectedTab: CLIENT_NOTIFICATIONS_TABS.PAYMENTS,
  },
];
